<section id="sensor-failure-management-grid" *ngIf="displayGrid">
  <p-table stripedRows #failTable [columns]="selectedCols" [value]="rows" [paginator]="true" [rows]="rowsPerPage"
    selectionMode="none" exportFilename="aqmesh-failed-sensors" styleClass="p-datatable-lg  p-datatable-gridlines"
    [resizableColumns]="true" stateStorage="local" stateKey="sensor_fail">
    <ng-template pTemplate="caption">
      <div class="p-grid">
        <div class="th-button p-col p-grid p-jc-end">
          <p-select ngDefaultControl [options]="rowsPerPageOptions" [(ngModel)]="rowsPerPage" positionStyle="fixed"
            pTooltip="Number of records display per page" tooltipEvent="hover" showDelay="500" hideDelay="500"
            styleClass="row-options" (onChange)="setPreferences()"></p-select>
          <label class="pageCountSeperator">|</label>

          <label *ngIf="failTable.totalRecords !== initialCount" class="row-count" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.rows_Total}}">{{failTable.totalRecords}}</label>
          <label *ngIf="failTable.totalRecords !== initialCount" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.row_Select}}" class="pageCountSeperator">of</label>
          <label tooltipEvent="hover" showDelay="500" hideDelay="500" class="row-count" positionStyle="fixed"
            pTooltip="{{tt === undefined ? col.header : tt.row_Select}}">{{initialCount}}</label>

          <button type="button" positionStyle="fixed" pTooltip="{{(tt === undefined) ? col.header : tt.row_Filter}}"
            tooltipEvent="hover" showDelay="500" hideDelay="500" pButton icon="fas fa-undo" label="Filters"
            class="p-button-raised p-button-secondary" (click)="reset()"></button>
          <p-multiSelect ngDefaultControl [options]="cols" [(ngModel)]="selectedCols"
            [ngModelOptions]="{standalone: true}" optionLabel="header" selectedItemsLabel="{0} columns"
            placeholder="Choose Columns" (onChange)="setPreferences()" [maxSelectedLabels]="0"></p-multiSelect>
          <button type="button" pButton icon="fas fa-magic" positionStyle="fixed" pTooltip="{{tt.resetColumn}}"
            tooltipEvent="hover" showDelay="500" hideDelay="500" class="p-button-raised p-button-secondary"
            (click)="clearCols()" [disabled]="isSearching"></button>
          <button type="button" pButton icon="fas fa-th" class="p-button-success" (click)="failTable.exportCSV()"
            [disabled]="(rows?.length ? rows?.length : 0) === 0" positionStyle="fixed"
            pTooltip="Export visible rows to CSV, for best results please set your spreadsheet to auto-import comma separated data files"
            tooltipEvent="hover" showDelay="500" hideDelay="500"></button>
          <button type="button" pButton icon="fas fa-file" class="p-button-success" (click)="export()"
            [disabled]="(rows?.length ? rows?.length : 0) === 0" positionStyle="fixed"
            pTooltip="Export all rows to CSV, for best results please set your spreadsheet to auto-import comma separated data files"
            tooltipEvent="hover" showDelay="500" hideDelay="500"></button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns">
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn [pSortableColumn]="col.field"
          [ngStyle]="{'width': col.colWidth}">
          <p-sortIcon [field]="col.field"></p-sortIcon>
          {{col.header}}
        </th>
        <th class="action-col"></th>
        <th class="action-col"></th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn [ngSwitch]="col.datatype" [ngStyle]="{'width': col.colWidth}">
          <ng-container *ngSwitchCase="'string'" [ngSwitch]="col.field">
            <p-multiSelect ngDefaultControl *ngSwitchCase="'alert_status_description'"
              [options]="sensorFailStatusFilter" [maxSelectedLabels]="0" (onChange)="search()"
              [(ngModel)]="searchFailures[col.field]" appendTo="body" selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
            <p-multiSelect ngDefaultControl *ngSwitchDefault [options]="col.filter" [maxSelectedLabels]="0"
              (onChange)="search()" [(ngModel)]="searchFailures[col.field]" appendTo="body"
              selectedItemsLabel="{0} {{col.header}}s">
            </p-multiSelect>
          </ng-container>
          <p-select ngDefaultControl *ngSwitchCase="'boolean'" [options]="boolCheckFilter"
            [(ngModel)]="searchFailures[col.field]" [ngModelOptions]="{standalone: true}"
            (onChange)="boolfilterRow(col.field, $event.value)" tooltipEvent="hover" appendTo="body">
          </p-select>
          <input ngDefaultControl *ngSwitchCase="'number'" pInputText type="number" maxlength="50"
            (input)="failTable.filter($event.target.value, col.field, 'contains')">
          <ng-container *ngSwitchCase="'Date'" [ngSwitch]="col.field">
            <p-datepicker ngDefaultControl [(ngModel)]="searchFailures.failure_date" appendTo="body"
              *ngSwitchCase="'failure_date'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="failTable.filter($event, col.field, 'failureDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="searchFailures.installation_date" appendTo="body"
              *ngSwitchCase="'installation_date'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
              (onSelect)="failTable.filter($event, col.field, 'installationDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)">
            </p-datepicker>
            <p-datepicker ngDefaultControl [(ngModel)]="searchFailures.shipped_date" appendTo="body"
              *ngSwitchCase="'shipped_date'" selectionMode="range" [readonlyInput]="false" dateFormat="dd-M-yy"
              [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              (onSelect)="failTable.filter($event, col.field, 'shippedDateRangeFilter')"
              (onClearClick)="clearFilter(col.field)">
            </p-datepicker>
          </ng-container>
          <input ngDefaultControl *ngSwitchDefault pInputText type="text" maxlength="50"
            (input)="failTable.filter($event.target.value, col.field, 'contains')" tooltipEvent="hover" showDelay="500"
            hideDelay="500" positionStyle="fixed" pTooltip="Please Enter">
        </th>

        <th class="action-col">
        </th>
        <th class="action-col">
          <button type="button" pButton icon="fas fa-plus" class="p-button-primary" (click)="add()"></button>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-searchFailures let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns">
          <td [class]="col.datatype" [ngSwitch]="col.datatype">
            <span class="fr" *ngSwitchCase="'decimal'">{{searchFailures[col.field]| number:'1.4-4'}}</span>
            <span *ngSwitchCase="'Date'">{{searchFailures[col.field] | date:'dd-MMM-yyyy'}}</span>
            <span *ngSwitchCase="'DateTime'">{{searchFailures[col.field] | date:'dd-MM-yyyy HH:mm'}}</span>
            <p-toggleButton ngDefaultControl *ngSwitchCase="'action'" [(ngModel)]="searchFailures[col.field]"
              [ngModelOptions]="{standalone: true}" [disabled]="disabled"></p-toggleButton>
            <aq-checkbox ngDefaultControl *ngSwitchCase="'boolean'" [(ngModel)]="searchFailures[col.field]"
              [ngModelOptions]="{standalone: true}" [disabled]="true"></aq-checkbox>
            <span *ngSwitchDefault>{{searchFailures[col.field]}}</span>
          </td>
        </ng-container>
        <td class="action-col">
          <button pButton type="button" icon="fas fa-chart-line" (click)="showData(searchFailures)"
            class=" p-button-primary"></button>
        </td>
        <td class="action-col">
          <button pButton type="button" icon="far fa-edit" (click)="edit(searchFailures)"
            class=" p-button-primary"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<div class="p-grid">
  <div class="p-col-12 no-float">
    <sensor-fail-edit (saveEvent)="saveEvent()" (cancelEvent)="cancelEvent()" [(visible)]="displayEdit">
    </sensor-fail-edit>
    <sensor-failures-audit-grid (cancelEvent)="cancelEvent()" [(visible)]="displayEdit"></sensor-failures-audit-grid>
  </div>
  <div class="p-col-12 no-float">
    <sensor-fail-chart (closeData)="closeData()" [(visible)]="displayData"></sensor-fail-chart>
  </div>
  <div class="p-col-12 no-float">
    <sensor-failure-manually-add (cancelEvent)="cancelEvent()" [(visible)]="displayManualAdd">
    </sensor-failure-manually-add>
  </div>
</div>
